export default __webpack_public_path__ + "static/media/pattern-circle1.00420175.jpg";